import React, { Component } from 'react';
import { Router, Route } from 'react-router-dom';
import history from '../history';
import { LocalizeProvider } from "react-localize-redux";

import Page from './Page'
import RequireAuth from './auth/RequireAuth'

import Login from './auth/Login'
import ForgotPassword from './auth/ForgotPassword'
import ResetPassword from './auth/ResetPassword'
import User from './user/User'
import UserView from './user/UserView'
import UserCreate from './user/UserCreate'
import Consultant from './consultant/Consultant'
import ConsultantView from './consultant/ConsultantView'
import Dashboard from './dashboard/DashboardView'
import Project from './project/Project'
import ProjectView from './project/ProjectView'
import ProjectForm from './project/FormContainer'
import QuaterlyReportView from './quaterlyreport/QuaterlyReportView';
import QuaterlyReportForm from './quaterlyreport/FormContainer'
import ConsultantForm from './consultant/FormContainer'
import ManagerView from './consultant/ManagerView'
import Program from './program/Program'
import ProgramForm from './program/FormContainer'
import ProgramView from './program/ProgramView'
import Rex from './rex/Rex'
import RexForm from './rex/FormContainer'
import RexView from './rex/RexView'
import EightD from './eightD/EightD'
import EightDForm from './eightD/FormContainer'
import EightDView from './eightD/EightDView'



const ContainerLogin = (props) => (
    <Page title="Login">
        <Login />
    </Page>
);

const ContainerForgotPassword = (props) => (
    <Page title="ForgotPassword">
        <ForgotPassword />
    </Page>
);

const ContainerResetPassword = (props) => (
    <Page title="ResetPassword">
        <ResetPassword />
    </Page>
);

const ContainerProject = (props) => (
    <Page title="Project">
        <Project wide />
    </Page>
);

const ContainerProjectView = (props) => (
    <Page title="ProjectView">
        <ProjectView wide />
    </Page>
);

const ContainerQuaterlyReportView = (props) => (
    <Page title="QuaterlyReportView">
        <QuaterlyReportView wide />
    </Page>
);

const ContainerQuaterlyReportForm = (props) => (
    <Page title="QuaterlyReportForm">
        <QuaterlyReportForm wide />
    </Page>
);

const ContainerProjectForm = (props) => (
    <Page title="ProjectForm">
        <ProjectForm wide />
    </Page>
);

const ContainerConsultant = (props) => (
    <Page title="Consultant">
        <Consultant wide />
    </Page>
);


const ContainerDashboard = (props) => {
    return (<Page title="Dashboard">
        <Dashboard wide />
    </Page>)
}

const ContainerConsultantView = (props) => {
    return (<Page title="ConsultantView">
        <ConsultantView wide />
    </Page>)
};

const ContainerConsultantForm = (props) => (
    <Page title="ConsultantForm">
        <ConsultantForm wide />
    </Page>
);

const ContainerUser = (props) => (
    <Page title="User">
        <User wide />
    </Page>
);

const ContainerUserView = (props) => (
    <Page title="UserView">
        <UserView wide />
    </Page>
);

const ContainerUserCreate = (props) => (
    <Page title="UserCreate">
        <UserCreate wide />
    </Page>
);

const ContainerManagerView = (props) => (
    <Page title="SystemView">
        <ManagerView wide />
    </Page>
);

const ContainerProgram = (props) => (
    <Page title="Program">
        <Program wide />
    </Page>
);

const ContainerProgramForm = (props) => (
    <Page title="ProgramForm">
        <ProgramForm wide />
    </Page>
);

const ContainerProgramView = (props) => (
    <Page title="ProgramView">
        <ProgramView wide />
    </Page>
);


const ContainerRex = (props) => (
    <Page title="Rex">
        <Rex wide />
    </Page>
);

const ContainerRexForm = (props) => (
    <Page title="RexForm">
        <RexForm wide />
    </Page>
);

const ContainerRexView = (props) => (
    <Page title="RexView">
        <RexView wide />
    </Page>
);

const ContainerEightD = (props) => (
    <Page title="EightD">
        <EightD wide />
    </Page>
);

const ContainerEightDForm = (props) => (
    <Page title="EightDForm">
        <EightDForm wide />
    </Page>
);

const ContainerEightDView = (props) => (
    <Page title="EightDView">
        <EightDView wide />
    </Page>
);


class App extends Component {
    render() {
        return (
            <LocalizeProvider>
                <Router history={history}>
                    <div >
                        <Route exact path="/" component={ContainerLogin} />
                        <Route exact path="/forgot-password" component={ContainerForgotPassword} />
                        <Route exact path="/reset-password/:token" component={ContainerResetPassword} />
                        <Route exact path="/user" component={RequireAuth(ContainerUser)} />
                        <Route exact path="/user/:id" component={RequireAuth(ContainerUserView)} />
                        <Route exact path="/createuser" component={RequireAuth(ContainerUserCreate)} />
                        <Route exact path="/consultant" component={RequireAuth(ContainerConsultant)} />
                        <Route exact path="/consultant/:id" component={RequireAuth(ContainerConsultantView)} />
                        <Route exact path="/consultant/edit/:id" component={RequireAuth(ContainerConsultantForm)} />
                        <Route exact path="/project" component={RequireAuth(ContainerProject)} />
                        <Route exact path="/project/:id" component={RequireAuth(ContainerProjectView)} />
                        <Route exact path="/quaterlyReport/:id" component={RequireAuth(ContainerQuaterlyReportView)} />
                        <Route exact path="/quaterlyReport/edit/:id" component={RequireAuth(ContainerQuaterlyReportForm)} />
                        <Route exact path="/project/edit/:id" component={RequireAuth(ContainerProjectForm)} />
                        <Route exact path="/dashboard" component={RequireAuth(ContainerDashboard)} />
                        <Route exact path="/manager/:id" component={RequireAuth(ContainerManagerView)} />
                        <Route exact path="/program" component={RequireAuth(ContainerProgram)} />
                        <Route exact path="/program/edit/:id" component={RequireAuth(ContainerProgramForm)} />
                        <Route exact path="/program/:id" component={RequireAuth(ContainerProgramView)} />
                        <Route exact path="/rex" component={RequireAuth(ContainerRex)} />
                        <Route exact path="/rex/:id" component={RequireAuth(ContainerRexView)} />
                        <Route exact path="/rex/edit/:id" component={RequireAuth(ContainerRexForm)} />
                        <Route exact path="/8D" component={RequireAuth(ContainerEightD)} />
                        <Route exact path="/8D/:id" component={RequireAuth(ContainerEightDView)} />
                        <Route exact path="/8D/edit/:id" component={RequireAuth(ContainerEightDForm)} />
                    </div>
                </Router>
            </LocalizeProvider>
        );
    }
}

export default App;
